export default "__VITE_ASSET__DVxTJCEO__"